import { useState, useEffect } from "react";
import DialogNew from "../../../designSystem/c-organism/dialogs/DialogNew";
import Button from "../../../designSystem/b-molecules/buttons/Button";
import Icon from "../../../designSystem/a-atoms/icons/Icon";
import { getFigmaEmbedUrl, isValidFigmaUrl } from "../utils/figmaUtils";
import style from "./FigmaPreviewDialog.module.css";

const FigmaPreviewDialog = ({ show, onClose, figmaUrl }) => {
  const [embedUrl, setEmbedUrl] = useState(null);
  const [iframeError, setIframeError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (show && figmaUrl) {
      if (isValidFigmaUrl(figmaUrl)) {
        const embed = getFigmaEmbedUrl(figmaUrl);
        setEmbedUrl(embed);
        setIframeError(false);
        setIsLoading(true);
      } else {
        setEmbedUrl(null);
        setIframeError(true);
        setIsLoading(false);
      }
    } else {
      setEmbedUrl(null);
      setIframeError(false);
      setIsLoading(true);
    }
  }, [show, figmaUrl]);

  function handleIframeLoad() {
    setIsLoading(false);
    setIframeError(false);
  }

  function handleIframeError() {
    setIsLoading(false);
    setIframeError(true);
  }

  function handleOpenInFigma() {
    if (figmaUrl) {
      window.open(figmaUrl, "_blank", "noopener,noreferrer");
    }
  }

  const hasError = !isValidFigmaUrl(figmaUrl) || iframeError;

  return (
    <DialogNew
      show={show}
      onClose={onClose}
      variants={["large","noPadding"]}
      title="Figma preview"
    >
      <div className={style.previewContainer}>
        {hasError ? (
          <div className={style.errorState}>
            <Icon>error_outline</Icon>
            <p>
              {!isValidFigmaUrl(figmaUrl)
                ? "Invalid Figma URL. Please check the URL and try again."
                : "Failed to load Figma preview. The frame may not be publicly accessible."}
            </p>
            {figmaUrl && (
              <Button onClick={handleOpenInFigma} preIcon="open_in_new">
                Open in Figma
              </Button>
            )}
          </div>
        ) : (
          <>
            {isLoading && (
              <div className={style.loadingState}>
                <Icon>hourglass_empty</Icon>
                <span>Loading Figma preview...</span>
              </div>
            )}
            {embedUrl && (
              <iframe
                src={embedUrl}
                className={style.figmaIframe}
                title="Figma Preview"
                allowFullScreen
                onLoad={handleIframeLoad}
                onError={handleIframeError}
                style={{ display: isLoading ? "none" : "block" }}
              />
            )}
            {/* <div className={style.actions}>
              <Button
                onClick={handleOpenInFigma}
                variants={["text"]}
                preIcon="open_in_new"
              >
                Open in Figma
              </Button>
            </div> */}
          </>
        )}
      </div>
    </DialogNew>
  );
};

export default FigmaPreviewDialog;
